class ProviderStore {
    insurers = null;
    brokers = null;

    constructor({ insurers, brokers }) {
        this.insurers = insurers;
        this.brokers = brokers;
    }

    getInsurerById = (id) => {
        return this.insurers.find(insurer => insurer.id === id) || null;
    };

    getBrokerById = (id) => {
        return this.brokers.find(broker => broker.id === id) || null;
    };

    getPrimaryProvider(insuranceType, province) {
        return this.brokers.find(broker => (
            broker?.isPrimaryFor?.includes(insuranceType)
            && broker?.provinces?.includes(province)
        )) || null;
    }

}

function createProviderStore(providers) {
    return new ProviderStore(providers);
}

export default createProviderStore;
